<template>
  <base-scroll-shadow
    v-if="agents.length > 1"
    class="agents-breadcrumb"
    scroll-target=".p-breadcrumb"
    mobile-only
    auto-scroll-to-end
  >
    <prime-breadcrumb
      :home="home"
      :model="model"
    >
      <template #item="{item}">
        <a
          v-if="!item.active"
          class="link"
          @click="() => click(item)"
        >
          {{ item.account }}
        </a>
        <template v-else>
          {{ item.account }}
        </template>
      </template>
    </prime-breadcrumb>
  </base-scroll-shadow>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import type { PropType } from 'vue'
import type { AgentType } from '@golden/gdk-agent-next'
import BaseScrollShadow from '@/components/base/BaseScrollShadow.vue'

export default defineComponent({
  name: 'AgentsBreadCrumb',
  components: {
    BaseScrollShadow
  },
  props: {
    agents: {
      type: Array as PropType<Array<{ account: string, id: number, layer?: AgentType | -1, index: number }>>,
      default: () => ([])
    }
  },
  emits: ['click'],
  setup (props, context) {
    const model = computed(() => props.agents
      .slice(1)
      .map((item, index, array) => ({ ...item, active: index === array.length - 1 })))

    const home = computed(() => props.agents[0] ?? {})

    const click = (data: unknown) => {
      context.emit('click', data)
    }

    return {
      home,
      model,
      click
    }
  }
})
</script>

<style lang="scss" scoped>
.agents-breadcrumb {
  :deep(.p-breadcrumb) {
    @apply p-0 bg-transparent border-0 text-4 overflow-y-hidden;

    @media screen and (max-width: 767px) {
      border-radius: 0;
    }
  }

  :deep(.pi.pi-chevron-right) {
    @apply i-ri-arrow-right-s-line text-3;
  }

  :deep(.p-menuitem) {
    color: #495057;
    white-space: nowrap;
  }
}
</style>
